import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const Section = Styled.section.attrs((props) => ({ id: 'contact' }))`
padding: 5rem 0;
background: ${color.tertiary};
text-align:center;
}`;

const SectionIntro = Styled.h2`
color:${color.primaryAlt};`;

const SectionLink = Styled.a.attrs(({ href }) => ({
  href,
}))`
color:${color.primary};
display: block;
font-size: 4rem;
margin: .8rem 0;
text-decoration: ${(props) => (props.decorate ? 'underline' : 'none')};
`;

const Contact = () => {
  return (
    <Section>
      <SectionIntro>Contact</SectionIntro>
      <SectionLink href="tel:481-624-3240">481-624-3240</SectionLink>
      <SectionLink decorate href="mailto:support@pawtastic.com">
        Email us
      </SectionLink>
    </Section>
  );
};

export default Contact;
